import { render } from "./DgWohnungStep10.vue?vue&type=template&id=b8455cf4&scoped=true"
import script from "./DgWohnungStep10.vue?vue&type=script&lang=js"
export * from "./DgWohnungStep10.vue?vue&type=script&lang=js"

import "./DgWohnungStep10.vue?vue&type=style&index=0&id=b8455cf4&scoped=true&lang=css"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8455cf4"]])

export default __exports__